import { Button } from '@cian/ui-kit';
import { numberToPrettyString, plural } from '@cian/utils';

import { useMemo } from 'react';

import { ASYNC_STATUS, type AsyncStatus } from '@/packages/typesafe-result';

import { HighwaysModalFooter } from '../components/HighwaysModalFooter/HighwaysModalFooter';

export function HighwaysModalFooterContainer({
  onApply,
  count,
  status,
}: {
  onApply: () => void;
  count?: number;
  status: AsyncStatus;
}): JSX.Element {
  const buttonText = useMemo(() => {
    return typeof count !== 'undefined'
      ? `${count < 1 ? 'Найдено' : 'Показать'} ` +
          `${numberToPrettyString(count)} ${plural(count, ['объект', 'объекта', 'объектов'])}`
      : 'Показать объекты';
  }, [count]);

  return (
    <HighwaysModalFooter>
      <Button loading={status === ASYNC_STATUS.PENDING} size="XS" theme="fill_primary" onClick={onApply}>
        {buttonText}
      </Button>
    </HighwaysModalFooter>
  );
}
